<app-breadcrumb [title]="'Novedades de desplazamientos'" [items]="['Pesv', 'Desplazamientos']"
  [active_item]="'Novedades del desplazamiento'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center">
      <i class="icofont icofont-notification me-2"></i>
      <h5 class="mb-0"><strong>NOVEDADES DEL DESPLAZAMIENTO</strong></h5>
      <button type="button" class="btn btn-sm btn-light ms-auto" (click)="volver()">
        <i class="icofont icofont-arrow-left me-1"></i>Volver
      </button>
    </div>

    <div class="card-body">

      <!-- INFORMACIÓN DEL DESPLAZAMIENTO -->
      <div class="card border-0 shadow-sm mb-3" *ngIf="desplazamiento">
        <div class="card-body row g-3">
          <div class="col-md-3">
            <small class="text-primary d-block">N° documento</small>
            <strong>{{ desplazamiento.n_documento || '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Fecha</small>
            <strong>{{ desplazamiento.fecha ? (desplazamiento.fecha | date:'dd/MM/yyyy') : '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Origen</small>
            <strong>{{ desplazamiento.PesvOrigenDesplazamientosData?.MUNICIPIO || '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Destino</small>
            <strong>{{ desplazamiento.PesvDestinoDesplazamientosData?.MUNICIPIO || '-' }}</strong>
          </div>
        </div>
      </div>

      <ul ngbNav #novedadTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

        <!-- TAB 1: FORMULARIO -->
        <li [ngbNavItem]="1" *ngIf="desplazamientoActivo || modoEdicion">
          <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> FORMULARIO NOVEDAD</strong></a>
          <ng-template ngbNavContent>
            <form [formGroup]="novedadForm" (ngSubmit)="guardar()" class="pt-3" novalidate>
              <div class="card border-0 shadow-sm mb-3">
                <div class="card-body row g-3">

                  <div class="col-md-6">
                    <label class="form-label text-dark">Tipo de novedad: <span class="text-danger">*</span></label>
                    <ng-select [items]="tiposNovedad" bindLabel="descripcion" bindValue="id"
                      [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un tipo..." formControlName="tipo"
                      [class.is-invalid]="novedadForm.get('tipo')?.invalid && novedadForm.get('tipo')?.touched">
                    </ng-select>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Fecha: <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" formControlName="fecha"
                      [class.is-invalid]="novedadForm.get('fecha')?.invalid && novedadForm.get('fecha')?.touched">
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Descripción: <span class="text-danger">*</span></label>
                    <textarea class="form-control" rows="3" formControlName="descripcion"
                      [class.is-invalid]="novedadForm.get('descripcion')?.invalid && novedadForm.get('descripcion')?.touched"></textarea>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Acción realizada</label>
                    <textarea class="form-control" rows="3" formControlName="accion_realizada"></textarea>
                  </div>

                </div>
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4">
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                  <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                  </span>
                  <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                  </span>
                </button>
                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion" (click)="cancelarEdicion()">
                  <i class="icofont icofont-close me-1"></i>Cancelar edición
                </button>
              </div>
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: LISTADO -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO NOVEDADES</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
              <div class="card-body pt-3">

                <div *ngIf="cargandoListado" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 mb-0">Cargando novedades...</p>
                </div>

                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroTipo" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos los tipos</option>
                      <option *ngFor="let t of tiposNovedad" [ngValue]="t.id">{{ t.descripcion }}</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control"
                        placeholder="Buscar por tipo, descripción o acción..." [(ngModel)]="filtro"
                        (input)="aplicarFiltro()">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                  <ng-container *ngIf="novedadesFiltradas.length > 0; else sinDatos">
                    <table id="tblNovedadesDesplazamientos" class="table table-bordered table-hover align-middle">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">FECHA</th>
                          <th class="text-center">TIPO</th>
                          <th class="text-center">DESCRIPCIÓN</th>
                          <th class="text-center">ACCIÓN REALIZADA</th>
                          <th class="text-center">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let n of novedadesFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                          <td class="text-center">{{ n.fecha | date:'dd/MM/yyyy' }}</td>
                          <td class="text-center">{{ n.TipoNovedadDesplazamientoData?.descripcion }}</td>
                          <td>{{ n.descripcion }}</td>
                          <td>{{ n.accion_realizada || '-' }}</td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center gap-1">
                              <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                ngbTooltip="Editar" *ngIf="n.estado === 1" (click)="editar(n)">
                                <i class="icofont icofont-pencil" style="font-size:.85rem;"></i>
                              </button>
                              <button *ngIf="n.estado === 0" class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                ngbTooltip="Activar" (click)="activar(n)">
                                <i class="icofont icofont-check-circled" style="font-size:.85rem;"></i>
                              </button>
                              <button *ngIf="n.estado === 1" class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                                ngbTooltip="Desactivar" (click)="eliminar(n)">
                                <i class="icofont icofont-trash" style="font-size:.85rem;"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="d-flex align-items-center">
                        <label class="me-2">Mostrar:</label>
                        <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>
                      <div class="text-center flex-grow-1">
                        Total Registros: <a class="badge badge-primary"><b>{{ novedadesFiltradas.length || 0
                            }}</b></a>
                      </div>
                      <div class="text-end">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay novedades registradas para este desplazamiento.</div>
                  </ng-template>
                </div>

                <div class="mt-4">
                  <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                      (click)="exportarExcel('tblNovedadesDesplazamientos','listado_novedades_desplazamientos')">
                      <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                      (click)="exportToPDF('tblNovedadesDesplazamientos','listado_novedades_desplazamientos','Listado de novedades del desplazamiento')">
                      <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="novedadTab" class="mt-2"></div>
    </div>
  </div>
</div>